import { OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, } from '@angular/forms';
import { ComparisonComponent } from './comparison/comparison.component';
var HomeComponent = /** @class */ (function () {
    function HomeComponent(_formBuilder, comp) {
        this._formBuilder = _formBuilder;
        this.comp = comp;
        this.isLinear = true;
        this.vocalUrl = 'home';
        this.midiData = 'home';
    }
    HomeComponent.prototype.getVocalUrl = function ($event) {
        // console.log('Vocal Url: ' + $event);
        this.vocalUrl = $event;
    };
    HomeComponent.prototype.getMidiData = function ($event) {
        // console.log('Midi Data: ' + $event);
        this.midiData = $event;
    };
    HomeComponent.prototype.ngOnInit = function () {
        this.firstFormGroup = this._formBuilder.group({
            firstCtrl: ['', Validators.required],
        });
        this.secondFormGroup = this._formBuilder.group({
            secondCtrl: ['', Validators.required],
        });
    };
    return HomeComponent;
}());
export { HomeComponent };
